import axios from 'axios'
import { Message } from 'element-ui';
import router from './../router'
/****** 创建axios实例 ******/
const service = axios.create({
	baseURL: SEVERS,
	timeout: 30000  ,// 请求超时时间
	// withCredentials: true,
 	// crossDomain: true
});
/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {
	config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // 登录不需要传token,看一下自己登录的接口包含哪个特殊字段
	var USER_TOKEN=''
	if(JSON.parse(window.localStorage.getItem("token"))){
		USER_TOKEN = JSON.parse(window.localStorage.getItem("token")).data.obj.token
	}
	// 登录不需要传token,看一下自己登录的接口包含哪个特殊字段
	if(USER_TOKEN && !config.url.includes('login') && !config.url.includes('getToken')){
		if(config.data == ''){
			config.data ='token='+ USER_TOKEN
		}else{
			config.data +='&token='+ USER_TOKEN
		}
	}
	return config;
}, error => { //请求错误处理
	Promise.reject(error)
});

/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
	response => { //成功请求到数据
//		let loadingInstance = Loading.service();
//		  loadingInstance.close();
		//这里根据后端提供的数据进行对应的处理
		if(response.data.code == '101000') {
      Message.error('token失效，请重新登录！')
      localStorage.removeItem('token')
			router.replace({
          path: '/login'
      });
      return
		
    }
    // else if(response.data.code == '102001'){
			// Message.error('对不起，您没有权限')
		// }
    else {
			return response;
		}
	},
	error => { //响应错误处理
		console.log(error);
		return Promise.reject(error)
	}
);
export default service;



// WEBPACK FOOTER //
// ./src/axios/request.js